import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export class Contacted extends React.Component<Props> {
  static defaultProps = {
    // eslint-disable-next-line no-console
    onClick: () => console.warn('default: Contacted.onClick'),
  };

  render() {
    return (
      <div>
        <p className="banner-customers__subtitle">
          <FormattedMessage id="home-expired/components/Contacted.tsx/1" />
        </p>
        <a className="button large brand" onClick={this.props.onClick}>
          <FormattedMessage id="home-expired/components/Contacted.tsx/2" />
        </a>
      </div>
    );
  }
}
